import { createAxiosInstance } from '../utils/helpers'
import axios from 'axios'
import Cookies from 'universal-cookie'
import querystring from 'querystring'
import { API_URL } from './index'
import * as types from './types'
import history from '../utils/history'

import { displayMessages, getUserConfig } from './common'

const cookies = new Cookies()

export function signIn({ username, password }) {
    return function (dispatch) {
        const fn0 = d => d({ type: types.PROCESAMIENTO_SIGNIN_PAGE, payload: true  })
        fn0(dispatch)

        const data = querystring.stringify({
            username: username,
            password: password
        })

        axios
            .post(`${API_URL}/account/signin`, data)
            .then((res) => {
                cookies.set('token', res.data.access_token, { path: '/' })
                const fn1 = d => d({ type: types.INICIAR_SESION })
                fn1(dispatch)
                history.push(window.FOLDER + '/')
            })
            .catch((err) => {
                const fn5 = d => d({ type: types.PROCESAMIENTO_SIGNIN_PAGE, payload: false  })
                fn5(dispatch)
                if (err.response && err.response.status === 401) {
                    dispatch({type: types.MOSTRAR_MENSAJE, payload: { type: 'danger', message: 'Nombre de usuario o contraseña incorrectas' }})
                } else {
                    displayMessages(dispatch, err)
                }
            })
    }
}

export function signOut() {
    const axiosWithToken = createAxiosInstance()
    return function (dispatch) {
        if (axiosWithToken) {
            axiosWithToken.get(`${API_URL}/account/signout`)
            .then((res) => {
                cookies.remove('token', { path: '/' })
                dispatch({ type: types.CERRAR_SESION })
                history.push(window.FOLDER + '/signin')
            })
            .catch((err) => {
                cookies.remove('token', { path: '/' })
                dispatch({ type: types.CERRAR_SESION })
                history.push(window.FOLDER + '/signin')
            })

        } else {
            cookies.remove('token', { path: '/' })
            dispatch({ type: types.CERRAR_SESION })
            history.push(window.FOLDER + '/signin')
        }
    }
}

export function changeInputs(attr, value) {
    return (dispatch) => {
        dispatch({ type: types.MODIFICAR_INPUTS_SIGNIN_PAGE, payload: { attr, value } })
    }
}

export function getUserFromToken(){
    const axiosWithToken = createAxiosInstance()
    return axiosWithToken.get(`${API_URL}/account/user`)
    .then((res) => {
        const data = res.data
        return data
    })
    .catch((err) => {
        throw err
    })
}

export function signInWithToken(token, expirate_date, url){
    return dispatch => {
        const data = querystring.stringify({
            token,
            expirate_date
        })
        axios.post(`${API_URL}/account/external-login`, data)
        .then(res => {
            cookies.set('token', token, { path: '/' })
            dispatch({type: types.INICIAR_SESION})
            dispatch(getUserConfig())
        })
        .catch(err => {
            displayMessages(dispatch, err)
            history.push(window.FOLDER + '/signin')
        })
    }
}


// WEBPACK FOOTER //
// ./src/actions/auth.js